/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module LicensingModule
 */

const moduleName = 'licensing';
const componentName = 'license-tier-switch-notification';
const prefix = `${moduleName}.${componentName}`;

export const switchedToLabel = `${prefix}.switchedToLabel`;
export const editSettingsLabel = `${prefix}.editSettingsLabel`;

export const ENGLISH = {
    [switchedToLabel]: 'Switched to {0}',
    [editSettingsLabel]: 'Edit Settings',
};
